import React, { useState } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';
import { FileDrop } from 'react-file-drop';
import API from '../../api.js';
import ProjEditImageDomUtil from './ProjEditImageDomUtil';

export default function ProjEditImageDom(props) {

    function render() {
        const { isDisabled, data } = props;
        // const { value } = this.state;

        return (
            <Col className="mb-2 projEditImage">
                <label>{data.name}</label><br />
                <ProjEditImageDomUtil
                    onChange={props.onChange}
                    isDisabled={isDisabled}
                    id={props.pid}
                    dataKey={props.dataKey}
                    value={props.value}
                    type={0} //0 : 專案, 1 : 廣告, 2 : 商品
                />
            </Col>
        );
    }
    return render();
}